import {
  Avatar,
  Box,
  Flex,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiBell, FiChevronDown, FiMenu } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { ROUTE_LINK_ITEMS } from "../constants/index";
import { useAppContext } from "../context";

const MobileNav = ({ onOpen, ...rest }) => {
  const { partner } = useAppContext();
  const [heading, setHeading] = useState("");
  const location = useLocation();

  useEffect(() => {
    const headingData = ROUTE_LINK_ITEMS.find(
      (obj) => obj.url === location?.pathname
    );
    setHeading(headingData.name);
  }, [location]);

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue("white", "gray.900")}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue("gray.200", "gray.700")}
      justifyContent={{ base: "space-between" }}
      {...rest}
    >
      <IconButton
        display={{ base: "flex", md: "none" }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Text
        display={{ base: "flex" }}
        fontSize="2xl"
        fontFamily="sans-serif"
        fontWeight={"500"}
        marginLeft={"20px"}
      >
        {heading}
      </Text>

      <HStack spacing={{ base: "0", md: "6" }}>
        <IconButton
          size="lg"
          variant="ghost"
          aria-label="open menu"
          icon={<FiBell />}
        />
        <Flex alignItems={"center"}>
          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: "none" }}
            >
              <HStack>
                <Avatar size={"sm"} name={partner?.name} />
                <VStack
                  display={{ base: "none", md: "flex" }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2"
                >
                  <Text fontSize="sm">{partner?.name}</Text>
                  <Text fontSize="xs" color="gray.600">
                    {partner?.companyName}
                  </Text>
                </VStack>
                <Box display={{ base: "none", md: "flex" }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue("white", "gray.900")}
              borderColor={useColorModeValue("gray.200", "gray.700")}
            >
              <Link to="/settings">
                <MenuItem>Settings</MenuItem>
              </Link>
              {/* <MenuItem>Billing</MenuItem> */}
              <MenuDivider />
              <MenuItem
                onClick={() => {
                  window.location.href = "/logout";
                }}
              >
                Sign out
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};
export default MobileNav;
